import '../styles/main.scss';
import 'htmx.org';
import './benchmark-result-edit';
import './bulk-benchmark-add';
import './hardware-edit';
import { initializeHardwareAutocompleteInputs } from './hardware-autocomplete';

initializeHardwareAutocompleteInputs();
